export default {
  brandName: "Basetao Sheet",
  navHome: "Startseite",
  navGuide: "Spreadsheet-Guide",
  navCategories: "Kategorien",
  navFaq: "FAQ",
  navShoppingGuide: "Einkaufs-Guide",
  articleNotFound: "Artikel nicht gefunden",
  tocTitle: "Inhaltsverzeichnis",
  backHome: "Zurück zur Startseite",
  relatedTitle: "Verwandte Ressourcen",
  authorName: "Basetao Sheet Redaktionsteam",
  authorRole: "Unabhängige Shopping-Recherche",
  articleFaqTitle: "Häufig gestellte Fragen",
  ctaBasetao: "Basetao Spreadsheet",
  ctaBuyNow: "Jetzt kaufen",
  languageLabel: "Sprache",
  footerTagline:
    "Eine unabhängige Ressourcen-Plattform für Basetao Spreadsheet-Recherche, Produktkategorien, Leitfäden und praktische Tipps zum Einkaufen in China.",
  footerNavTitle: "Entdecken",
  footerCategoriesTitle: "Kategorien",
  footerLegalTitle: "Rechtliches",
  footerPrivacy: "Datenschutz",
  footerTerms: "Bedingungen",
  footerDisclaimer: "Haftungsausschluss",
  footerAbout: "Über uns",
  footerContact: "Kontakt",
  footerDisclaimerText:
    "Dies ist eine unabhängige Informationswebsite. Wir sind weder mit Basetao verbunden noch die offizielle Website von Basetao. Alle Marken gehören ihren jeweiligen Inhabern. Verfügbarkeit, Preise und Versandkosten können sich jederzeit ändern.",
  footerCopyright: "Alle Rechte vorbehalten.",
  footerMadeWith: "Unabhängige Ressource · Regelmäßig aktualisiert",
};